module.exports = __webpack_public_path__ + "img/jaxx-radio.884397db.png";